import React, { useState } from 'react';
import './game.css';

const kanaList = [
    "あ", "い", "う", "え", "お", "か", "き", "く", "け", "こ",
    "さ", "し", "す", "せ", "そ", "た", "ち", "つ", "て", "と",
    "な", "に", "ぬ", "ね", "の", "は", "ひ", "ふ", "へ", "ほ",
    "ま", "み", "む", "め", "も", "や", "", "ゆ", "", "よ",
    "ら", "り", "る", "れ", "ろ", "わ","", "を","", "ん",
    "小", "", "", "", "", "", "", "", "゛", "゜"
];

const dakutenMap: { [key: string]: string } = {
    "か": "が", "き": "ぎ", "く": "ぐ", "け": "げ", "こ": "ご",
    "さ": "ざ", "し": "じ", "す": "ず", "せ": "ぜ", "そ": "ぞ",
    "た": "だ", "ち": "ぢ", "つ": "づ", "て": "で", "と": "ど",
    "は": "ば", "ひ": "び", "ふ": "ぶ", "へ": "べ", "ほ": "ぼ"
};

const handakutenMap: { [key: string]: string } = {
    "は": "ぱ", "ひ": "ぴ", "ふ": "ぷ", "へ": "ぺ", "ほ": "ぽ"
};

const miniMojiMap: { [key: string]: string } = {
    "あ": "ぁ", "い": "ぃ", "う": "ぅ", "え": "ぇ", "お": "ぉ",
    "つ": "っ", "や": "ゃ", "ゆ": "ゅ", "よ": "ょ"
};

const correctAnswer = "けいがいか";

interface HistoryEntry {
    input: string[];
    flipStatus: (boolean | null)[];
}

const Game: React.FC = () => {
    const [clearMessage, setClearMessage] = useState<string | null>(null);
    const [input, setInput] = useState<string[]>([]);
    const [fripInput, setFripInput] = useState<string[]>([]);
    const [flipStatus, setFlipStatus] = useState<(boolean | null)[]>(Array(5).fill(null));
    const [history, setHistory] = useState<HistoryEntry[]>([]);
    const [isFlipping, setIsFlipping] = useState<boolean>(false);
    const [inputCount, setInputCount] = useState<number>(0);

    const handleKanaClick = (kana: string) => {
        if (isFlipping) return;
        if (kana === "゛") {
            if (input.length > 0 && dakutenMap[input[input.length - 1]]) {
                const updatedInput = [...input];
                updatedInput[updatedInput.length - 1] = dakutenMap[input[input.length - 1]];
                setInput(updatedInput);
            }
        } else if (kana === "゜") {
            if (input.length > 0 && handakutenMap[input[input.length - 1]]) {
                const updatedInput = [...input];
                updatedInput[updatedInput.length - 1] = handakutenMap[input[input.length - 1]];
                setInput(updatedInput);
            }
        } else if (kana === "小") {
            if (input.length > 0 && miniMojiMap[input[input.length - 1]]) {
                const updatedInput = [...input];
                updatedInput[updatedInput.length - 1] = miniMojiMap[input[input.length - 1]];
                setInput(updatedInput);
            }
        } else if (input.length < 5) {
            setInput([...input, kana]);
        } else if (input.length === 5) {
            if (!flipStatus.includes(null)) {
                setInput([kana]);
                setFlipStatus(Array(5).fill(null));
            }
        }
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (input.length === 5 && !isFlipping && flipStatus.includes(null)) {
            setInputCount(inputCount + 1);
            setIsFlipping(true);

            const ans = input.join('');
            const newFlipStatus = ans === correctAnswer ? [true,true,true,true,true] : [false,false,false,false,false];
            const newFripInput = ans === correctAnswer ? input : input.map((char, index) => char == "け" ? "け" : "か");

            setFripInput(newFripInput);
            newFlipStatus.forEach((_, index) => {
                setFlipStatus(prev => {
                    const updated = [...prev];
                    updated[index] = newFlipStatus[index];
                    return updated;
                });
            });

            setTimeout(() => {
                setIsFlipping(false);
                if (ans === correctAnswer) {
                    setClearMessage("CLEAR!");
                }
            }, 2000);

            // 履歴に追加し、直近5回分に制限
            setHistory(prev => [{ input, flipStatus: newFlipStatus }, ...prev.slice(0, 4)]);
        }
    };

    const handleClear = () => {
        if (!isFlipping) {
            setInput([]);
            setFlipStatus(Array(5).fill(null));
        }
    };

    return (
        <div className="App">
            <header>
                <p><label htmlFor="popup" id="txt_label">ルール</label></p>
            </header>

            <input className="rule-input" type="checkbox" id="popup"/>

            <div id="overlay">
                <label htmlFor="popup" id="bg_gray"></label>

                <div id="window">
                    <label htmlFor="popup" id="btn_cloth">
                        <span></span>
                    </label>
                    <h2>ルール</h2>
                    <div className="rule-text">
                        ・ひらがな5文字の正解を送信すればクリアです。<br/>
                        ・送信ボタンで解答を送る事ができます。<br />
                        ・正解の単語でない場合はその文字列に応じて判定を返します。<br />
                        ・正解の単語は意味のある知名度のある単語となります。<br />
                    </div>
                </div>
            </div>

            {clearMessage &&
                <div className="overlay-clear">
                    <label id="bg_gray"></label>
                    <div id="window">
                        <h1>{clearMessage}</h1>
                        <div className="rule-text">
                            {`「GOMOJI」を${inputCount}回でクリアした！`}
                        </div>
                        <div className="sns-button">
                            <a href={`https://twitter.com/intent/tweet?text=web%E8%AC%8E%E3%80%8CGOMOJI%E3%80%8D%E3%82%92${inputCount}%E5%9B%9E%E3%81%A7%E3%82%AF%E3%83%AA%E3%82%A2%E3%81%97%E3%81%9F%EF%BC%81%0D%0A%0D%0A%E3%81%93%E3%81%93%E3%81%8B%E3%82%89%E3%83%97%E3%83%AC%E3%82%A4%E2%86%93%0D%0Ahttps%3A%2F%2Fridkmy.github.io%2Fgomoji%2F%0D%0A%0D%0A%23GOMOJI%E8%AC%8E+%23%E8%AC%8E%E8%A7%A3%E3%81%8D+%23web%E8%AC%8E`} target="_blank" rel="noopener noreferrer">Xでポストする</a>
                        </div>
                        <div className="credit">
                            謎制作：京極みやび（<a href="https://x.com/miyabi_ky" target="_blank" rel="noopener noreferrer">@miyabi_ky</a>）<br/>
                            WEB実装：でこ（<a href="https://x.com/ridkmy" target="_blank" rel="noopener noreferrer">@ridkmy</a>）
                        </div>
                    </div>
                </div>
            }

            <div className="title">
                <h1>GOMOJI</h1>
            </div>
            {/*<div className="history">*/}
            {/*    {history.reverse().map((entry, index) => (*/}
            {/*        <div key={index} className="history-entry">*/}
            {/*            {entry.input.map((char, i) => (*/}
            {/*                <div key={i} className={`square ${entry.flipStatus[i] !== null ? (entry.flipStatus[i] ? 'correct' : 'incorrect') : ''}`}>*/}
            {/*                    <div className="square-inner">*/}
            {/*                        <div className="square-front">*/}
            {/*                            {char}*/}
            {/*                        </div>*/}
            {/*                        <div className={`square-back ${entry.flipStatus[i] !== null ? (entry.flipStatus[i] ? 'correct' : 'incorrect') : ''}`}>*/}
            {/*                            {'あ'}*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    ))}*/}
            {/*</div>*/}
            <form onSubmit={handleSubmit}>
                <div className="squares">
                    {Array.from({ length: 5 }, (_, i) => (
                        <div key={i} className={`square ${flipStatus[i] !== null ? (flipStatus[i] ? 'correct' : 'incorrect') : ''}`}>
                            <div className="square-inner">
                                <div className="square-front">
                                    {input[i] || ''}
                                </div>
                                <div className={`square-back ${flipStatus[i] !== null ? (flipStatus[i] ? 'correct' : 'incorrect') : ''}`}>
                                    {fripInput[i]}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="clear-button" type="button" onClick={handleClear}>クリア</button>
                <button className="submit-button" type="submit">送信</button>
            </form>
            <div className="kana-buttons">
                {kanaList.map((kana) => (
                    (kana == "") ? <div className="buttonBlank" /> : <button key={kana} onClick={() => handleKanaClick(kana)}>{kana}</button>
                ))}
            </div>
        </div>
    );
}

export default Game;